'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n'], ['\n  position: relative;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  min-width: 3em;\n  width:auto;\n  position: relative;\n'], ['\n  min-width: 3em;\n  width:auto;\n  position: relative;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  position: relative;\n  display: block;\n  font-family:monospace;\n  letter-spacing: 0;\n  white-space:pre;\n  direction: rtl;\n  ', '\n\n  span {\n    padding:0 1px;\n    display: inline-block;\n    position: relative;\n  }\n  span:hover:before{\n    ', '\n  }\n  span:hover ~ span:before {\n    ', '\n  }\n'], ['\n  width: 100%;\n  position: relative;\n  display: block;\n  font-family:monospace;\n  letter-spacing: 0;\n  white-space:pre;\n  direction: rtl;\n  ', '\n\n  span {\n    padding:0 1px;\n    display: inline-block;\n    position: relative;\n  }\n  span:hover:before{\n    ', '\n  }\n  span:hover ~ span:before {\n    ', '\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 82px;\n  height: 14px;\n  background: url("https://denmfovn3e0c3.cloudfront.net/prod/bha-images/yelp-stars.png");\n  margin-top: 4px;\n  ', '\n'], ['\n  width: 82px;\n  height: 14px;\n  background: url("https://denmfovn3e0c3.cloudfront.net/prod/bha-images/yelp-stars.png");\n  margin-top: 4px;\n  ', '\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  width: 100%;\n  position: relative;\n  display: block;\n  white-space:pre;\n  padding: 0px 10px;\n\n  color: #9B9B9B;\n  font-size: 1em;\n  font-weight: bold;\n\n  span {\n    width: 50%;\n    padding:0;\n    display: inline-block;\n    position: relative;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  span:first-child {\n  \tfloat: left;\n  \ttext-align: left;\n  }\n  span:last-child {\n  \tfloat: right;\n  \ttext-align: right;\n  }\n'], ['\n  width: 100%;\n  position: relative;\n  display: block;\n  white-space:pre;\n  padding: 0px 10px;\n\n  color: #9B9B9B;\n  font-size: 1em;\n  font-weight: bold;\n\n  span {\n    width: 50%;\n    padding:0;\n    display: inline-block;\n    position: relative;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  span:first-child {\n  \tfloat: left;\n  \ttext-align: left;\n  }\n  span:last-child {\n  \tfloat: right;\n  \ttext-align: right;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StarContainer = _styledComponents2.default.div(_templateObject);

var StarHolder = _styledComponents2.default.div(_templateObject2);

var StarSet = _styledComponents2.default.span(_templateObject3, function (props) {
  return props.interactive ? "display: flex; justify-content: space-around; font-size: 3em" : '';
}, function (props) {
  return props.interactive ? "content: '\\e977';" : '';
}, function (props) {
  return props.interactive ? "content: '\\e977';" : '';
});

var RioYelpStarSet = _styledComponents2.default.div(_templateObject4, function (props) {
  return props.mode === 'ZeroStar' && '\n    background-position: 0px 140px;\n  ' || props.mode === 'HalfStar' && '\n    background-position: 0px 126px;\n  ' || props.mode === 'OneStar' && '\n    background-position: 0px 126px;\n  ' || props.mode === 'OneAndHalfStar' && '\n    background-position: 0px 112px;\n  ' || props.mode === 'TwoStar' && '\n    background-position: 0px 98px;\n  ' || props.mode === 'TwoAndHalfStar' && '\n    background-position: 0px 84px;\n  ' || props.mode === 'ThreeStar' && '\n    background-position: 0px 70px;\n  ' || props.mode === 'ThreeAndHalfStar' && '\n    background-position: 0px 56px;\n  ' || props.mode === 'FourStar' && '\n    background-position: 0px 42px;\n  ' || props.mode === 'FourAndHalfStar' && '\n    background-position: 0px 28px;\n  ' || props.mode === 'FiveStar' && '\n    background-position: 0px 14px;\n  ';
});

var StarLabel = _styledComponents2.default.div(_templateObject5);

var MozartStarRating = function (_Component) {
  _inherits(MozartStarRating, _Component);

  function MozartStarRating(props) {
    _classCallCheck(this, MozartStarRating);

    var _this = _possibleConstructorReturn(this, (MozartStarRating.__proto__ || Object.getPrototypeOf(MozartStarRating)).call(this, props));

    _this.state = {
      rating: _this.props.stars
    };
    return _this;
  }

  _createClass(MozartStarRating, [{
    key: 'onChange',
    value: function onChange(rating) {
      var _this2 = this;

      if (this.props.interactive) {
        this.setState({
          rating: rating
        }, function () {
          if (_this2.props.onChange) {
            _this2.props.onChange(rating);
          }
        });
      }
    }
  }, {
    key: 'getStars',
    value: function getStars() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0, 0, 0, 0, 0];
      var interactive = this.props.interactive;

      var stars = [];
      for (var count = 0; count < 5; count++) {
        var starClassName = 'icon-StarBlank';
        if (data[count] === 0.5) starClassName = 'icon-StarHalf';
        if (data[count] === 1) starClassName = 'icon-StarFull';
        stars.push(_react2.default.createElement('span', { className: starClassName, onClick: this.onChange.bind(this, count + 1) }));
      }
      return _react2.default.createElement(
        StarSet,
        { interactive: interactive },
        stars.reverse()
      );
    }
  }, {
    key: 'getRioYelpStars',
    value: function getRioYelpStars(mode) {
      return _react2.default.createElement(RioYelpStarSet, { mode: mode });
    }
  }, {
    key: 'getStar',
    value: function getStar() {
      var rating = this.state.rating;
      var isZeroStar = rating === 0;
      var isHalfStar = rating >= 0.001 && rating <= 0.749;
      var isOneStar = rating >= 0.750 && rating <= 1.249;
      var isOneAndHalfStar = rating >= 1.250 && rating <= 1.749;
      var isTwoStar = rating >= 1.750 && rating <= 2.249;
      var isTwoAndHalfStar = rating >= 2.250 && rating <= 2.749;
      var isThreeStar = rating >= 2.750 && rating <= 3.249;
      var isThreeAndHalfStar = rating >= 3.250 && rating <= 3.749;
      var isFourStar = rating >= 3.750 && rating <= 4.249;
      var isFourAndHalfStar = rating >= 4.250 && rating <= 4.749;
      var isFiveStar = rating >= 4.750;
      var starSet = [];
      var starLabel = '';
      var isRioYelp = this.props.isRioYelp;


      if (isZeroStar) starSet.push(isRioYelp ? this.getRioYelpStars('ZeroStar') : this.getStars());
      if (isHalfStar) starSet.push(isRioYelp ? this.getRioYelpStars('HalfStar') : this.getStars([0.5, 0, 0, 0, 0]));
      if (isOneStar) starSet.push(isRioYelp ? this.getRioYelpStars('OneStar') : this.getStars([1, 0, 0, 0, 0]));
      if (isOneAndHalfStar) starSet.push(isRioYelp ? this.getRioYelpStars('OneAndHalfStar') : this.getStars([1, 0.5, 0, 0, 0]));
      if (isTwoStar) starSet.push(isRioYelp ? this.getRioYelpStars('TwoStar') : this.getStars([1, 1, 0, 0, 0]));
      if (isTwoAndHalfStar) starSet.push(isRioYelp ? this.getRioYelpStars('TwoAndHalfStar') : this.getStars([1, 1, 0.5, 0, 0]));
      if (isThreeStar) starSet.push(isRioYelp ? this.getRioYelpStars('ThreeStar') : this.getStars([1, 1, 1, 0, 0]));
      if (isThreeAndHalfStar) starSet.push(isRioYelp ? this.getRioYelpStars('ThreeAndHalfStar') : this.getStars([1, 1, 1, 0.5, 0]));
      if (isFourStar) starSet.push(isRioYelp ? this.getRioYelpStars('FourStar') : this.getStars([1, 1, 1, 1, 0]));
      if (isFourAndHalfStar) starSet.push(isRioYelp ? this.getRioYelpStars('FourAndHalfStar') : this.getStars([1, 1, 1, 1, 0.5]));
      if (isFiveStar) starSet.push(isRioYelp ? this.getRioYelpStars('FiveStar') : this.getStars([1, 1, 1, 1, 1]));
      if (!starSet.length) starSet.push(isRioYelp ? this.getRioYelpStars('ZeroStar') : this.getStars());

      starLabel = _react2.default.createElement(
        StarLabel,
        null,
        this.props.leftLabel && _react2.default.createElement(
          'span',
          null,
          this.props.leftLabel
        ),
        this.props.rightLabel && _react2.default.createElement(
          'span',
          null,
          this.props.rightLabel
        )
      );

      return [starLabel, starSet];
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          themeId = _props.themeId;

      return _react2.default.createElement(
        StarContainer,
        { 'data-qa': this.props.testId, 'data-theme': themeId },
        _react2.default.createElement(
          StarHolder,
          { style: style },
          this.getStar()
        )
      );
    }
  }]);

  return MozartStarRating;
}(_react.Component);

MozartStarRating.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  style: _propTypes2.default.object,
  stars: _propTypes2.default.oneOf([_propTypes2.default.string, _propTypes2.default.number]),
  interactive: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  isRioYelp: _propTypes2.default.bool
};
MozartStarRating.defaultProps = {
  testId: 'MozartStarRating',
  themeId: 'MozartStarRating',
  interactive: false,
  isRioYelp: false
};
exports.default = MozartStarRating;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartStarRating/MozartStarRating.js
// module id = 1846
// module chunks = 1